import { render, staticRenderFns } from "./unsubscribeEmail.vue?vue&type=template&id=808afcc0"
import script from "./unsubscribeEmail.vue?vue&type=script&lang=js"
export * from "./unsubscribeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports